module.exports = __webpack_public_path__ + "static/media/new-link-generated-icon.0117422d.svg";